import type { ColumnDef } from "@tanstack/react-table";
import type { ApEmail } from "@/accounts-payable/types";

export const subjectCol: ColumnDef<ApEmail> = {
  accessorKey: "subject",
  header: "Subject",
  meta: { size: "280px" },
  cell: ({ row }) => <span>{row.original.subject}</span>,
};
